export { default as ChangePasswordForm } from './ChangePasswordForm.container';
